<template>
    <b-card
            :border-variant="isAnnulled ? 'danger' : 'primary'"
            header-class="gallery-shift-header"
            class="gallery-shift-card"
            :class="{'gallery-shift-card--annulled': isAnnulled}"
            body-class="p-0"
    >
        <template #header>
            <div class="gallery-shift-title">
                <span>
                    Смена
                    <router-link
                        :to="{name: 'report-card', params: {id: data.shiftId}}"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="gallery-shift-report-link"
                        :aria-label="'Открыть отчёт ' + data.shiftId + ' в новой вкладке'"
                        title="Открыть карточку отчёта в новой вкладке"
                    >{{ data.shiftId }}</router-link>
                    от {{ shiftDate }}
                </span>
                <b-badge v-if="isAnnulled" variant="danger">
                    АННУЛИРОВАН — НЕ УЧИТЫВАТЬ
                </b-badge>
            </div>
            <div v-if="works.length" class="gallery-shift-works">
                <span class="gallery-shift-works__label">Работы:</span>
                <span>{{ visibleWorks.map(work => work.name).join(' · ') }}</span>
                <button v-if="works.length > 2" type="button" class="gallery-shift-works__more"
                    :aria-expanded="String(worksExpanded)" @click="worksExpanded = !worksExpanded">
                    {{ worksExpanded ? 'Свернуть' : 'Ещё ' + (works.length - 2) }}
                </button>
            </div>
            <small v-if="isAnnulled && data.annulmentReason" class="gallery-shift-annulment-reason">
                Причина: {{ data.annulmentReason }}
            </small>
        </template>
        <Images
                :shiftId="data.shiftId"
                :images="data.files"
                :shifts="allShifts"
                :shift-index="shiftIndex"
                :shifts-completed="shiftsCompleted"
                :load-more-shifts="loadMoreShifts"
                :annulled="isAnnulled"
                :annulment-reason="data.annulmentReason || ''"
        />
    </b-card>
</template>

<script>
    import Images from "../../images/Images";
    export default {
        name: "ShiftImages",
        data() { return {worksExpanded: false}; },
        components: {
            Images
        },
        computed: {
            works() {
                return (Array.isArray(this.data.works) ? this.data.works : []).filter(work => work && work.name);
            },
            visibleWorks() { return this.worksExpanded ? this.works : this.works.slice(0, 2); },
            isAnnulled() {
                return Boolean(this.data && this.data.isAnnulled);
            },
            shiftDate() {
                const shift = this.data || {};
                return this.$moment(shift.dateTime).format("DD.MM.YYYY dddd HH:mm");
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            allShifts: {
                type: Array,
                default: () => []
            },
            shiftIndex: {
                type: Number,
                default: 0
            },
            shiftsCompleted: {
                type: Boolean,
                default: false
            },
            loadMoreShifts: {
                type: Function,
                default: null
            }
        }
    }
</script>

<style scoped>
.gallery-shift-card {
    overflow: hidden;
}

.gallery-shift-works {
    color: #536577;
    font-size: .78rem;
    font-weight: 400;
    line-height: 1.5;
    margin-top: 5px;
    overflow-wrap: anywhere;
}
.gallery-shift-works__label { color: #637587; margin-right: 5px; }
.gallery-shift-works__more { background: transparent; border: 0; color: #245e7b; font-size: inherit; padding: 2px 5px; text-decoration: underline; }

.gallery-shift-card--annulled {
    background: #fff3f3;
}

.gallery-shift-title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    justify-content: space-between;
}

.gallery-shift-report-link {
    color: #245e7b;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.gallery-shift-annulment-reason {
    color: #721c24;
    display: block;
    font-weight: 700;
    margin-top: 4px;
}

>>> .gallery-shift-header {
    font-size: 0.95rem;
    line-height: 1.25;
    padding: 0.5rem 0.75rem;
}

@media (max-width: 767.98px) {
    .gallery-shift-card {
        border-left: 0;
        border-right: 0;
        margin-left: -1px;
        margin-right: -1px;
    }

    >>> .gallery-shift-header {
        font-size: 0.86rem;
        padding: 0.45rem 0.6rem;
    }
}

</style>
